import React from "react";
import { Box, Container, Typography, Link } from "@mui/material";

const TermsOfUse = () => {
  return (
    <Box sx={{ py: 6, bgcolor: "#f9f9f9" }}>
      <Container maxWidth="md">
        <Typography variant="h4" gutterBottom fontWeight="bold">
          Terms Of Use
        </Typography>

        <Typography variant="body1" paragraph>
          By accessing our website and services, you agree to these Terms of Use.
        </Typography>

        <Typography variant="body1" paragraph>
          In using this website you are deemed to have read and agreed to the following terms and conditions:
        </Typography>

        <Typography variant="body1" paragraph>
          Your use of our Internet sites or any of the information, links, products, or services offered on those sites (collectively, the “Services”) is subject to these Terms of Use (these “Terms”). MyFreshTools, at its sole discretion, may change the Terms, conditions, and operation of this website (the “Site”) at any time without notice to you. By using this Site and/or any of its Services, you agree to the Terms, including any modifications we make, and further, waive any rights or claims you may have against MyFreshTools.
        </Typography>

        <Typography variant="h6" gutterBottom>Privacy Statement</Typography>
        <Typography variant="body1" paragraph>
          We are committed to protecting your privacy. Please read our{" "}
          <Link href="/privacy-policy" underline="hover">
            Privacy Policy
          </Link>{" "}
          for full details.
        </Typography>

        <Typography variant="h6" gutterBottom>YouTube API Use</Typography>
        <Typography variant="body1" paragraph>
          Our services may use YouTube's Application Interface Program (API). By using our Services, you are agreeing to be bound by the{" "}
          <Link href="https://www.youtube.com/t/terms" target="_blank" rel="noopener" underline="hover">
            YouTube Terms of Service
          </Link>.
        </Typography>

        <Typography variant="h6" gutterBottom>Confidentiality</Typography>
        <Typography variant="body1" paragraph>
          Client records are regarded as confidential and will not be divulged to any third party unless legally required. Clients may request to view or copy their records with reasonable notice. We may provide clients with related documents as part of our agreement.
        </Typography>

        <Typography variant="body1" paragraph>
          We will not sell, share, or rent your personal information. Any emails from us will relate only to agreed services or products.
        </Typography>

        <Typography variant="h6" gutterBottom>Disclaimer, Exclusions and Limitations</Typography>
        <Typography variant="body1" paragraph>
          WE AND OUR ADVERTISERS, SUPPLIERS AND LICENSORS PROVIDE THE MYFRESHTOOLS SITE AND SERVICES ON AN “AS IS" AND “AS PROVIDED” BASIS, WITHOUT ANY WARRANTY OR CONDITION OF ANY KIND, EXPRESS OR IMPLIED. WE DO NOT GUARANTEE UNINTERRUPTED OR ERROR-FREE SERVICES.
        </Typography>
        <Typography variant="body1" paragraph>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL OUR LIABILITY EXCEED $100.
        </Typography>
        <Typography variant="body1" paragraph>
          We are not responsible for any third-party products or services, even if advertised or offered through our site. You waive any claims against MyFreshTools regarding third-party offerings.
        </Typography>

        <Typography variant="h6" gutterBottom>Copyright Notice</Typography>
        <Typography variant="body1" paragraph>
          All content and brand elements on this site are protected by copyright and intellectual property laws. Brand names and specific services are trademarked.
        </Typography>

        <Typography variant="h6" gutterBottom>Force Majeure</Typography>
        <Typography variant="body1" paragraph>
          Neither party shall be liable for failures due to events beyond their control (e.g., natural disasters, war, civil unrest). Affected parties must notify the other and try to comply with existing terms.
        </Typography>

        <Typography variant="h6" gutterBottom>Licenses [Refund Policy]</Typography>
        <Typography variant="body1" paragraph>
          No refunds are provided for licenses within 30 days. We offer a trial to test the features. Refunds are only possible on the first order upon request.
        </Typography>

        <Typography variant="h6" gutterBottom>Licenses [Auto-Renew and Cancellation]</Typography>
        <Typography variant="body1" paragraph>
          Licenses renew automatically unless canceled. Cancel anytime to stop future payments. Access remains for the paid period.
        </Typography>

        <Typography variant="h6" gutterBottom>Notification of Changes</Typography>
        <Typography variant="body1" paragraph>
          We may update these terms and will notify users via homepage or email. Continued use of the site means acceptance of any changes.
        </Typography>

        <Typography variant="body1" paragraph>
          These terms and conditions form part of the agreement between the client and MyFreshTools. Your use of this site confirms your acceptance of these terms. Your statutory consumer rights are unaffected.
        </Typography>

        <Typography variant="h6" gutterBottom>General</Typography>
        <Typography variant="body1" paragraph>
          These Terms are governed by California law, with jurisdiction in San Diego County. We reserve the right to refuse service at any time. These Terms are subject to existing laws and legal process.
        </Typography>
      </Container>
    </Box>
  );
};

export default TermsOfUse;